import { getShopifyCollectionUrl } from "@/lib/shopify";

const SHOP_LINKS = [
  { label: "Crowns", key: "crowns" },
  { label: "Classics", key: "classics" },
  { label: "Tracksuits", key: "tracksuits" },
  { label: "T-Shirts", key: "tshirts" },
  { label: "Shop All", key: "all" },
];

const NAV_LINK_BASE =
  "block py-3 text-sm tracking-[0.3em] uppercase text-stone-300 hover:text-[#F4EFE6]";

export const NavMobileDrawer = ({ onClose }) => (
  <div className="md:hidden bg-stone-950/97 backdrop-blur-md border-t border-stone-800/60 -mx-6 px-6 py-6">
    <a href="/" onClick={onClose} className={NAV_LINK_BASE}>
      Home
    </a>
    <p className="block py-3 text-sm tracking-[0.3em] uppercase text-stone-500 mt-2">Shop</p>
    {SHOP_LINKS.map((l) => (
      <a
        key={l.key}
        href={getShopifyCollectionUrl(l.key)}
        className="block py-2 pl-4 text-xs tracking-[0.3em] uppercase text-stone-400 hover:text-[#F4EFE6]"
      >
        — {l.label}
      </a>
    ))}
    <a href="/footwear" onClick={onClose} className={`${NAV_LINK_BASE} mt-2`}>
      Footwear
    </a>
    <a href="/chronicles" onClick={onClose} className={NAV_LINK_BASE}>
      Archive
    </a>
    <a href="/about" onClick={onClose} className={NAV_LINK_BASE}>
      About
    </a>
  </div>
);

export { SHOP_LINKS };
export default NavMobileDrawer;
